import { SetupChat as UsecaseReduxSetupChat } from '~/domain/usecases/chat/redux';

import { ReduxSetupChat } from '~/data/store/reducer/chat/usecases';

export const makeReduxSetupChat = (): UsecaseReduxSetupChat =>
  new ReduxSetupChat();
